import { forwardRef } from 'react';
import { getToastStyles } from './ToastStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { NotificationBaseBody } from '../NotificationBaseBody/NotificationBaseBody.js';

const Toast = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    type,
    className,
    ...rest
  } = _ref;
  return jsx("article", {
    css: getToastStyles(type),
    ref: ref,
    className: className,
    children: jsx(NotificationBaseBody, {
      type: type,
      ...rest
    })
  });
});
Toast.displayName = 'Toast';

export { Toast };
//# sourceMappingURL=Toast.js.map
